const READER_CONNECTOR_VERSION = import.meta.env.VITE_READER_CONNECTOR_VERSION;

export default {
    /**
     * Validates an incoming PostMessage for security and protocol compliance.
     * @param {MessageEvent} message - The PostMessage event to validate
     * @param {string[]} expectedEvents - Array of valid event names
     * @param {string} hostLocation - The host URL to validate against
     * @returns {boolean} True if the message is valid
     */
    validatePostMessage(message, expectedEvents, hostLocation) {
        if (!hostLocation || !hostLocation.startsWith(message.origin)) {
            return false;
        }

        if (typeof message.data.target !== 'string') {
            console.debug(`'message.data' does not contain 'target' property`);
            return false;
        }
        if (message.data.target !== 'volpe') {
            console.debug(`'message.data.target' is not equal to 'volpe`);
            return false;
        }
        if (typeof message.data.connectorVersionTarget !== 'string') {
            console.debug(`'message.data' does not contain 'connectorVersionTarget' property`);
            return false;
        }
        if (message.data.connectorVersionTarget !== READER_CONNECTOR_VERSION) {
            console.debug(`'message.data.connectorVersionTarget' is not equal to ${READER_CONNECTOR_VERSION}`);
            return false;
        }
        if (typeof message.data.timestamp !== 'number') {
            console.debug(`'message.data' does not contain 'timestamp' property`);
            return false;
        }
        if (typeof message.data.type !== 'string') {
            console.debug(`'message.data' does not contain 'type' property`);
            return false;
        }
        if (message.data.type !== 'event') {
            console.debug(`'message.data.type' is not equal to 'event`);
            return false;
        }
        if (typeof message.data.name !== 'string') {
            console.debug(`'message.data' does not contain 'name' property`);
            return false;
        }
        if (!expectedEvents.includes(message.data.name)) {
            console.debug(`'message.data.name' is not an expected event`, {
                expectedEvents,
                received: message.data.name,
            });
            return false;
        }

        return true;
    },
};
